// src/data/blogsData.js

import hero from "../img/Hero.jpeg";
import aim from "../img/g26.png";
import journey from "../img/g12.png";
import grassroot from "../img/grassroot.jpg";

const BlogsData = [
  {
    id: 1,
    img: hero,
    title:
      "The Genesis of AICURD | National Level NGO for Rural & Urban Development in India",
    author: "Admin",
    metadescription:
      "Discover the genesis of AICURD, a national-level NGO established in 1984 under the Societies Registration Act. Committed to rural and urban development, AICURD promotes community participation, grassroots initiatives, national integration, and holistic programs for improving quality of life across India.",

    description: `
The All India Centre for Urban and Rural Development (AICURD), registered under the Societies Registration Act of 1860, was established in 1984 as a National Level Voluntary Organisation for promoting improved quality of human life, human settlements, and physical and social environments in India.

To transform this vision into reality, AICURD undertook to:

- Establish Constituent Units in almost all the districts of the country.  
- Encourage voluntary efforts among the people to participate in nation-building programmes.  
- Take up comprehensive developmental programmes encompassing economic, social, and ideological aspects of human life.  
- Ensure involvement of grassroots level workers in planning, formulation, and implementation of programmes.  
- Organize need-based programmes on the suggestions of the concerned Unit’s management.  
- Propagate and espouse the cause of national integration and communal harmony to strengthen national unity.  
    `,
  },
  {
    id: 2,
    img: aim,
    title:
      "AICURD Aims & Objectives | NGO for Rural & Urban Development, Women Empowerment & Community Welfare",
    author: "Admin",
    metadescription:
      "Discover the aims and objectives of AICURD, a national-level NGO dedicated to rural and urban development, women empowerment, skill training, Khadi and Village Industries, social welfare, legal aid, and community upliftment across India.",

    description: `
AICURD’s aims and objectives include:

- Undertake innovative and experimental welfare projects in urban and rural areas with focus on disadvantaged sections such as Scheduled Castes, Scheduled Tribes, OBCs, women, children, aged, handicapped, infirm, and mentally challenged.  

- Promote Khadi and Village Industries, establish emporia and sanitary marts, form cooperative societies, provide housing and resettlement support, and develop low-cost building materials.  

- Raise funds by way of loans, grants, donations, and fees from state/central governments, institutions, and international agencies for welfare and development activities.  

- Review delivery systems for development and suggest ways of making them more effective for the urban and rural poor.  

- Collaborate with Panchayati Raj institutions, voluntary agencies, industries, business houses, governments, UN, and international agencies.  

- Undertake **training, research, consultancy, and extension services** in relation to urban and rural development.  

- Serve as a nodal agency for national, international, government, and non-government organizations in India.  

- Foster awareness and community participation for urban and rural development.  

- Promote **legal aid**, cultural heritage awareness, national integration, and communal harmony.  

- Develop laboratory facilities for preparation of audio-visual aids.  
    `,
  },
  {
    id: 3,
    img: journey,
    title: "Our Journey – AICURD | NGO for Urban & Rural Development in India",
    author: "Admin",
    metadescription:
      "AICURD’s journey since 1985 – empowering communities across India through education, health, women empowerment, rural development & social upliftment.",

    description: `
The All India Centre for Urban and Rural Development (AICURD) was founded in 1985 by Shri D.P. Ray, Member of Parliament.  

After sustaining itself for three years with non-funded projects, AICURD began receiving government support in 1988 and grew into a national-level NGO operational in six states:  
**Uttarakhand, Gujarat, Rajasthan, West Bengal, Jammu & Kashmir, and Delhi.**

---

### Key Milestones in Our Journey

**1988-89**  
- Hosted a National Seminar on prevention of atrocities on women (Dept. of Women & Child Development).  
- Established a Sewing-cum-Training Centre for poor women and girls.  

**1989-90**  
- Conducted socio-economic surveys of SC/STs (Dumka, Bihar).  
- Installed hand pumps in Moradabad (UP) & Sidhi (MP) under Drinking Water Project.  

**1990-92**  
- Launched Adult Education (Golaghat, Assam).  
- Organized Youth Training, Leadership Camps, and National Integration Camps.  
- Expanded water and awareness projects with CAPART support.  

**1993-95**  
- Introduced Shorthand/Typing courses in Jalpaiguri.  
- UNICEF-supported education projects for downtrodden.  
- Launched Bharat Nirman Action Plan with 110 events across 19 states.  

**1998-2005**  
- Expanded Vocational Training, SHGs, and Jute Development.  
- Participated in Yamuna Action Plan.  
- Established Jan Shikshan Sansthan (JSS) for skill development.  
- Organized health, HIV/AIDS, and solid waste management projects in Delhi.  

**2006-2015**  
- Promoted Bamboo, Cane, and Jute crafts.  
- Established crèches for working mothers in West Bengal.  
- Conducted Right to Information campaigns and environment awareness drives.  
- NABARD-funded SHG and livelihood initiatives in Uttarakhand.  

---

Through three decades of community service, AICURD has continuously adapted and expanded its projects in **education, health, sanitation, skill training, SHGs, women empowerment, and social welfare**.  

Our journey continues with the promise:  

*"And miles to go before I sleep,  
And miles to go before I sleep."*  
    `,
  },
  {
    id: 4,
    img: grassroot,
    title:
      "AICURD’s Grassroots Development in Jalpaiguri, West Bengal – Empowering SHGs, Artisans & Women",
    author: "Admin",
    metadescription:
      "AICURD empowers rural communities in Jalpaiguri, West Bengal through SHGs, skill training, handicrafts promotion under AHVY, women empowerment, child welfare, and sustainable livelihood initiatives.",

    description: `
AICURD has been instrumental in empowering marginalized people towards sustainable livelihoods.  

- Formed **520+ SHGs** in Jalpaiguri district, of which 325 are credit linked.  
- Promoted handicrafts via supply of raw materials, technology inputs, artisan training, and marketing support.  
- Implemented projects under **Ambedkar Hastshilp Vikas Yojana (AHVY)**, supporting artisans in jute, cane, bamboo, and weaving.  
- Established a **Craft Development Centre (CDC)** for diversified jute products with Ministry of Textiles support.  

### Key Initiatives
- Conducted skill and design workshops for artisans.  
- Provided credit support to SHGs with 90% repayment success.  
- Organized child labour schools (with NCLP support).  
- Established **10 crèche centers** for children of working mothers in Jalpaiguri.  
- Implemented food processing projects with Ministry of Food Processing Industries.  
- Conducted Entrepreneurship Development Programmes (EDPs).  
- NABARD and Nehru Yuva Kendra-supported skill development for SHG women.  

---

### AHVY Programme Highlights
- Issued **Artisan Identity Cards**.  
- Provided toolkits, prototype development, and R&D assistance.  
- Supported artisan marketing via fairs, exhibitions, and emporia.  
- Created Raw Material Banks and Common Facility Centres.  
- Offered financial aid for entrepreneurship training and cluster management.  

---

AICURD continues to connect SHGs, artisans, women, and youth with **sustainable livelihood opportunities**, working closely with NABARD, Ministry of Textiles, Social Welfare Board, and Food Processing Industries.  

From rural villages in West Bengal to metropolitan Delhi, AICURD remains committed to:  
- Women empowerment  
- Skill development  
- Education support  
- Child welfare  
- Sanitation and health awareness  

✅ Building stronger communities through inclusive growth and sustainable development.  
    `,
  },
];

export default BlogsData;
